/** WARP-939 — the two sides of the admin Users tab. */
export const USER_TAB = {
  DEALER: 'dealer',
  WPC: 'wpc',
}

/** `user_type` values as the API spells them. */
export const USER_TYPE = {
  DEALER: 'Dealer User',
  WPC: 'WPC User',
}

/**
 * WPC roles from most to least privileged, mirroring
 * `core.rules.WPC_ROLE_PRIVILEGE_ORDER`.
 */
export const WPC_ROLE_PRIVILEGE_ORDER = ['Executive', 'Manager', 'Administrator', 'Read Only']

/** Query parameter that carries the selected tab, so it survives a reload. */
export const TAB_PARAM = 'type'
